import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AllTeam = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data
  const fetchData = async () => {
    try {
      const response = await fetch("https://mirai-server.vercel.app/all-team");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Delete item
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(`https://mirai-server.vercel.app/delete-team/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.deletedCount === 1) {
        alert("Item deleted successfully!");
        setData(data.filter((item) => item._id !== id)); // Update the state to reflect the deleted item
      } else {
        alert("Failed to delete the item.");
      }
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <div className="w-full py-6 border-b border-gray-300 px-6">
        <h1 className="text-2xl font-bold text-gray-700 font-roboto">
          All Team
        </h1>
      </div>

      <div class="relative overflow-x-auto mx-6 mt-10 border border-gray-200 rounded">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                #
              </th>

              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Image
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Full Name
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Designation
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Delete
              </th>
            </tr>
          </thead>
          {data.reverse().map((item, index) => (
            <tbody>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  class="px-6 py-4 font-roboto text-lg text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {index + 1}
                </th>

                <td class="px-6 py-4 font-roboto text-lg">
                  <img
                    class="w-16 h-16 rounded-full object-cover"
                    src={item.singleImage}
                    alt="Rounded avatar"
                  />
                </td>
                <td class="px-6 py-4 font-roboto text-lg">{item.title}</td>
                <td class="px-6 py-4 font-roboto text-lg">
                  {item.designation}
                </td>

                <td class="px-6 py-4 font-roboto text-lg">
                  <button onClick={() => handleDelete(item._id)}>Delete</button>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      </div>
    </div>
  );
};

export default AllTeam;
